export function getCurrentUserPermissionsKey() {
  return ['currentUser', 'permissions']
}
